App.namespace.wrap('es6.shared.storage_manager', function () {
  let storageType = null;

  /**
   * Initialize Storage Manager by specifying which type of storage it should use
   *
   * @param {string} type - 'session' or 'local'
   * @returns {Object} - Returns public API of the Storage Manager for method chaining
   */
  const init = (type) => {
    try {
      switch (type) {
        case 'session':
          storageType = window.sessionStorage;
          break;
        case 'local':
          storageType = window.localStorage;
          break;
        default:
          console.error('Wrong argument passed to Storage Manager');
          storageType = null;
      }
    } catch (err) {}
    return publicAPI;
  }

  /**
   * Save item to Storage
   *
   * @param {string} name - Unique name of the object to save
   * @param {Object} item - Object to save
   * @returns {boolean} - true if succeeded, false if failed
   */
  const set = (name, item) => {
    if (typeof storageType === 'object') {
      try {
        storageType.setItem(name, item);
        return true;
      } catch (err) {
        console.error(err);
        return false;
      }
    }
    console.error('storageType is not an object');
    return false;
  }

  /**
   * Get item from Storage
   *
   * @param {string} name - Name of the object to get
   * @returns {Object|null} - Requested object if it exists or null if failed
   */
  const get = (name) => {
    if (typeof storageType === 'object') {
      try {
        return storageType.getItem(name);
      } catch (err) {
        return null;
      }
    }
    return null;
  }

  /**
   * Remove item from Storage
   *
   * @param {string} name - Name of the object to remove
   * @returns {boolean} - True if succeeded, false if failed.
   * Note: true is returned even if the object didn't exist.
   */
  const remove = (name) => {
    if (typeof storageType === 'object') {
      try {
        storageType.removeItem(name);
        return true;
      } catch (err) {
        return false;
      }
    }
    return false;
  }

  const publicAPI = {
    init,
    set,
    get,
    remove,
  }

  return publicAPI;
});
